import script from "./MaterialDeliveryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialDeliveryDialog.vue?vue&type=script&setup=true&lang=js"

import "./MaterialDeliveryDialog.vue?vue&type=style&index=0&id=55933b94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55933b94"]])

export default __exports__